var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", { staticClass: "date_class" }, [_vm._v("日期（Data）")]),
      _c("el-date-picker", {
        staticStyle: { width: "450px" },
        attrs: {
          clearable: false,
          "end-placeholder": "结束时间（Hora de fim）",
          "range-separator": "-",
          "start-placeholder": "开始时间（Hora de início）",
          type: "daterange",
          "value-format": "yyyy-MM-dd",
          size: "small",
          "picker-options": _vm.pickerOptions,
        },
        on: { change: _vm.dateChange },
        model: {
          value: _vm.timeValue,
          callback: function ($$v) {
            _vm.timeValue = $$v
          },
          expression: "timeValue",
        },
      }),
      _c(
        "span",
        { staticStyle: { display: "inline-block", margin: "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.search },
            },
            [_vm._v("查询（Consultar）")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info", plain: "", size: "small" },
              on: { click: _vm.reset },
            },
            [_vm._v("重置（Resetar）")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.exportAll } },
            [_vm._v("导出（Exportar）")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%", "margin-top": "20px" },
          attrs: {
            size: "small",
            "max-height": "600",
            border: "",
            "header-cell-style": {
              background: "#e1e1e1",
              color: "#000",
              "font-size": "15px",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号（No.）", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._l(_vm.tableHeaderList, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                align: "center",
                label: item.label,
                prop: item.prop,
                "min-width": item.cloWidth,
                "show-overflow-tooltip": false,
                "class-name": _vm.getColumnClass(index),
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "firstUnloadMissCount" ||
                        item.prop === "firstArrivalMissCount" ||
                        item.prop === "firstBagMissCount" ||
                        item.prop === "firstLoadMissCount"
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#1990ff",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetail(scope.row, item.prop)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row[item.prop]))]
                            )
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop] ||
                                    scope.row[item.prop] === 0
                                    ? scope.row[item.prop]
                                    : "--"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryForm.pageNumber,
              "page-sizes": [10, 20, 50, 100, 500, 1000],
              "page-size": _vm.queryForm.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.page,
              "size-change": _vm.search,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }